<template>
  <div class="main">
 <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="子车型对比"  />
      <div  class="r action-btn-box" v-show="!viewResult">
           <el-button @click="selectCars"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >{{buttonLabel}} <svg-icon name="play" size="12" ></svg-icon> </el-button> 
        </div>
      <xy-toolbox-menu class="r">
        <!--  <xy-toolbox-menu-item custom><div class="custom-content"></div></xy-toolbox-menu-item><xy-toolbox-menu-item divided/>-->
        <xy-toolbox-menu-item icon="car_search" @click="chooseCars"  v-show="viewResult">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel" v-show="viewResult">Excel导出  </xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">

    </SearchBar>
    <div v-if="viewResult" style="margin-top:20px;"></div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/NewSearchBar.vue";

import draggable from "vuedraggable";
export default {
  name: "EquipModelCompare",
  components: {
    SearchBar,
    draggable
  },
  data() {
    return {
      tableCfg: null,
      viewResult: false,
      buttonLabel: "子车型对比",
      currentModuleName: "EquipModelCompare",
      showDialog: false,
      pk_type: 1,

      carlist: [],
      self: [],
      competingCars: []
    };
  },
  methods: {
    ...mapMutations("commonsearch", ["setPivotTableKey", "clearSearch"]),
    ...mapActions("commonsearch", ["savePivotTableAsync"]),
    selectCars() {
      let compareCars = this.displayResult;
 
      console.log(compareCars);
      if (compareCars.length < 2) {
        this.$message({
          message: "至少选项2个车型/车款",
          duration: 2000
        });  
        return;
      }
      var models = compareCars.filter((item, index) => {
        return (
          compareCars.findIndex(obj => {
            return obj.modeId === item.modeId;
          }) === index
        );
      });

      this.self = [];
      this.competingCars = [];
     
        for (var i = 0; i < compareCars.length; i++) {
          let car = compareCars[i];
          let name = this.showSelectionSubmodel ? car.name : car.model;
          this.self.push({
            id: i,
            modeId: car.modeId,
            carId: car.id,
            name: name,
            msrp: car.msrp
          });
        }
       
       this.$router.push({
            name: 'equippk4',
            params: {
              'q': this.self
            }
          });
    },

    handleCommand(command) {
      this.pk_type = command;
      this.$message("click on item " + command);
      var selfId = this.self[0].carId;
      var compId = this.competingCars[0].carId;
      var params = [];
      if (this.pk_type == 1) {
        for (var i = 0; i < this.self.length; i++) {
          params.push([this.self[i], this.competingCars[i]]);
        }
        this.$router.push({
          name: "equippk1",
          params: {
            q: params
          }
        });
      } else if (this.pk_type == 3) {
        for (var j = 0; j < this.self.length; j++) {
          params.push([this.self[j], this.competingCars[j]]);
        }
        this.$router.push({
          name: "equippk3",
          params: {
            q: params
          }
        });
      } else if (this.pk_type == 4) {
        for (var k = 0; k < this.self.length; k++) {
          params.push(this.self[k]);
        }
        for (var l= 0; l < this.competingCars.length; l++) {
          params.push(this.competingCars[l]);
        }
        this.$router.push({
          name: "equippk4",
          params: {
            q: params
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters("commonsearch", [
      "searchCategories",
      "hasSelectionResult",
      "hasSearchResult",
      "showSelectionSubmodel",
      "selectionResult",
      "searchResult"
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description"
      };
    },
    isDisabled() {
      return function(type) {
        if (type == 0) {
          return this.self.length == 0 || this.competingCars.length == 0;
        }
        if (type == 1 || type == 2) {
          if (!this.showSelectionSubmodel) {
            return true;
          }
          return !(this.self.length == this.competingCars.length);
        }
        return false;
      };
    },
    // 显示数据
    displayResult() {
      if (this.showSelectionSubmodel) {
        return this.selectionResult;
      } else {
        // 最小颗粒为子车型
        return this.selectionResult.filter((item, index) => {
          return (
            this.selectionResult.findIndex(obj => {
              return obj.model === item.model;
            }) === index
          );
        });
      }
    }
  },
  watch: {
    showSelectionSubmodel: function(newVal) {
      this.buttonLabel = newVal ? "对比子车型" : "对比子车型";
    }
  }
};
</script>
  